import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCountryQuery } from '../../api/countryApi';


export const getCountry = createAsyncThunk('country/getCountry', async (data, { dispatch }) => {
    dispatch(resetReducer())
    const response = await getCountryQuery(data);
    return response.data;
});



const CountrySlice = createSlice({
    name: 'country',
    initialState: {
        countryLoader: false,
        data: [],
        status: null,
        message: ""
    },
    reducers: {
        resetReducer: (state) => {
            state.countryLoader = false;
            state.data = [];
            state.status = null
            state.message = ""
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCountry.pending, (state, action) => {
                state.countryLoader = true;
                state.status = false;
            })
            .addCase(getCountry.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.countryLoader = false;
                state.message = action.payload.msg
                state.countryLoader = false;
                state.status = true
            })
            .addCase(getCountry.rejected, (state, action) => {
                state.countryLoader = false;
                state.status = false;
            });
    },
});

export const { resetReducer } = CountrySlice.actions;
export default CountrySlice.reducer;
